import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
    ListGroup,
    ListGroupItem,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    Input,
    Label,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Button,
    Spinner
} from "reactstrap";
import classnames from "classnames";
import { loadAnimation } from "lottie-web";
import { defineLordIconElement } from "lord-icon-element";
import Slider from 'react-rangeslider';
import SimpleBar from 'simplebar-react';
import { Link } from 'react-router-dom';
import { addGrape, getAllGrapes, getGrapeDetails, getMainGrapes, updateGrape } from '../../helpers/api/product/product';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { addGrapeOfTheWeek, getGrapeOfTheWeekDetails, updateGrapeOfTheWeek } from '../../helpers/api/information/information';
// register lottie and define custom element
defineLordIconElement(loadAnimation);

const GrapeOfTheWeekDetails = () => {
    const [enable, setEnable] = useState({
        all: false,
        doButton: true,
        cancelButton: false,
        refreshButton: true,
        form: true
    });
    const [formValues, setFormValues] = useState({
        startDate: "",
        endDate: "",
        grapeId: -1
    });
    const [dropdownItems, setDropdownItems] = useState({
        grapes: []
    });
    const [print, setPrint] = useState({
        enable: false
    });
    const [texts, setTexts] = useState({
        title: "",
        doButton: "Ekle"
    });
    const [pageType, setPageType] = useState("");
    const [loading, setLoading] = useState(false);
    const [visibility, setVisibility] = useState({
        loading: true,
        cancelButton: true
    });

    const history = useHistory();
    const location = useLocation();
    const { id, type } = location.state.params;

    const handleGrapeDetails = async () => {
        try {
            let result = await getGrapeOfTheWeekDetails({ id });
            if (!result.success) return console.log("Bir hata oluştu");

            let data = result.data;

            console.log(data);

            setFormValues({
                ...formValues,
                startDate: data.StartDate.split("T")[0] || "",
                endDate: data.EndDate.split("T")[0] || "",
                grapeId: data.GrapeID || -1
            });

            if (type != "ADD") {
                setPrint({
                    ...print,
                    enable: true
                });
            }
        } catch (error) {
            return console.log(error);
        }
    }

    const fillDropdowns = async () => {
        try {
            let responseGrapes = await getAllGrapes();
            if (!responseGrapes.success) return console.log(responseGrapes.data);

            setDropdownItems({
                ...dropdownItems,
                grapes: responseGrapes.data.map(grape => ({ id: grape.id, name: grape.GrapeName }))
            });

            if (formValues.grapeId == -1) {
                setFormValues({
                    ...formValues,
                    grapeId: responseGrapes.data[0].id || -1
                });
            }
        } catch (error) {
            return console.log(error);
        }
    }

    const doFirstProcess = async () => {
        try {
            setPageType("LOADING");
            await fillDropdowns();

            if (id) await handleGrapeDetails();

            setPageType(type);
        } catch (error) {
            return console.log(error);
        }
    };

    const handleDo = () => {
        if (pageType == "INFORM") {
            setPageType("EDIT");
        } else if (pageType == "EDIT") {
            handleUpdateGrape();
        }
        else if (pageType == "ADD") {
            handleAddGrape();
        }
    }

    const handleCancel = () => {
        setPageType("INFORM");
    }

    const handleRefresh = () => {
        confirmAlert({
            title: 'Confirm to Delete',
            message: 'Are you sure to refresh?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => {
                        if (pageType == "INFORM" || pageType == "EDIT") {
                            reloadContent();
                        } else if (pageType == "ADD") {
                            setFormValues({
                                ...formValues,
                                name: "",
                                nameEng: "",
                                mainGrape: "",
                                image: null
                            });
                        }
                    }
                },
                {
                    label: 'No'
                }
            ]
        });
    }

    const reloadContent = async () => {
        try {
            setLoading(true);

            await doFirstProcess();

            setLoading(false);
        } catch (error) {
            return console.log(error);
        }
    }

    const alertValidationError = (element) => {
        alert("Lütfen " + element + " alanını doldurunuz.");
    }

    const controlNecessaryValues = () => {
        if (formValues.startDate.trim() == "") return alertValidationError("Start Date");
        if (formValues.endDate.trim() == "") return alertValidationError("End Date");
        if (formValues.grapeId == -1) return alertValidationError("Grape");
        return true;
    }

    const handleUpdateGrape = async () => {
        try {
            setLoading(true);
            if (controlNecessaryValues() === true) {
                let data = {
                    ...formValues,
                };

                let response = await updateGrapeOfTheWeek({
                    id,
                    ...data,
                    now: new Date()
                });

                if (!response.success) return console.log(response.data);
                history.push("/grape-of-the-week-table");
            }
            setLoading(false);
        } catch (error) {
            return console.log(error);
        }
    }

    const handleAddGrape = async () => {
        try {
            setLoading(true);
            if (controlNecessaryValues() === true) {
                let data = {
                    ...formValues
                };

                let response = await addGrapeOfTheWeek({
                    ...data,
                    now: new Date()
                });

                if (!response.success) return console.log(response.data);
                history.push("/grape-of-the-week-table");
            }
            setLoading(false);
        } catch (error) {
            return console.log(error);
        }
    }

    useEffect(() => {
        switch (type) {
            case "EDIT":
                setTexts({
                    ...texts,
                    title: "Grape Düzenle",
                    button: "Kaydet"
                });
                break;
            case "ADD":
                setTexts({
                    ...texts,
                    title: "Grape Ekle",
                    button: "Ekle"
                });
                break;
            case "INFORM":
                setTexts({
                    ...texts,
                    title: "Grape Bilgileri",
                    button: "Düzenle"
                });
                break;
            default:
                break;
        }

        doFirstProcess();
    }, []);

    useEffect(() => {
        document.title = texts.title;
    }, [texts.title]);

    useEffect(() => {
        if (!pageType) return

        switch (pageType) {
            case "INFORM":
                setTexts({
                    ...texts,
                    title: "Grape Bilgileri",
                    doButton: "Düzenle"
                });
                setEnable({
                    ...enable,
                    form: false,
                    cancelButton: false,
                    all: true
                });
                setVisibility({
                    ...visibility,
                    cancelButton: true,
                    loading: false
                });
                break;
            case "EDIT":
                setTexts({
                    ...texts,
                    title: "Grape Düzenleme",
                    doButton: "Kaydet"
                });
                setEnable({
                    ...enable,
                    form: true,
                    cancelButton: true,
                    all: true
                });
                setVisibility({
                    ...visibility,
                    cancelButton: true,
                    loading: false
                });
                break;
            case "ADD":
                setTexts({
                    ...texts,
                    title: "Grape Ekleme"
                });
                setEnable({
                    ...enable,
                    form: true,
                    cancelButton: false,
                    all: true
                });
                setVisibility({
                    ...visibility,
                    cancelButton: false,
                    loading: false
                });
                break;
            case "LOADING":
                setEnable({
                    ...enable,
                    all: false
                });
                setVisibility({
                    ...visibility,
                    loading: true
                });
                break;
            default:
                break;
        }
    }, [pageType]);

    useEffect(() => {
        if (loading) {
            setEnable({
                ...enable,
                all: false
            });
            setVisibility({
                ...visibility,
                loading: true
            });
        } else {
            setEnable({
                ...enable,
                all: true
            });
            setVisibility({
                ...visibility,
                loading: false
            });
        }
    }, [loading]);

    return (
        <>
            <div className="page-content">
                <fieldset disabled={!enable.all}>
                    <Container fluid={true}>
                        <Card>
                            <CardHeader>
                                <Row className='align-items-end'>
                                    <Col sm={1}><Spinner color='danger' hidden={!visibility.loading}>loading ...</Spinner></Col>
                                    <Col sm={4}>
                                        <h2 className="mb-0">{texts.title}</h2>
                                        <p>Kaydetmek için '<span style={{ color: "red" }}>*</span>'la işaretlenmiş alanları doldurunuz.</p>
                                    </Col>
                                    <Col sm={4}></Col>
                                    <Col sm={1}><Button hidden={!visibility.cancelButton} disabled={!enable.cancelButton} onClick={handleCancel} color='warning'>İptal Et</Button></Col>
                                    <Col sm={1}><Button disabled={!enable.refreshButton} onClick={handleRefresh} color='danger'>Yenile</Button></Col>
                                    <Col sm={1}><Button disabled={!enable.doButton} onClick={handleDo} color='success'>{texts.doButton}</Button></Col>
                                </Row>
                            </CardHeader>
                            <CardBody className="form-steps">
                                <Form>
                                    <fieldset disabled={!enable.form}>
                                        <Row>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="firstNameinpu" className="form-label">Start Date<span style={{ color: "red" }}>*</span></Label>
                                                    <Input value={formValues.startDate} onChange={(e) => setFormValues({ ...formValues, startDate: e.target.value })} type="date" className="form-control" id="firstNameinputt" />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="firstNameinpu" className="form-label">End Date<span style={{ color: "red" }}>*</span></Label>
                                                    <Input value={formValues.endDate} onChange={(e) => setFormValues({ ...formValues, endDate: e.target.value })} type="date" className="form-control" id="firstNameinpu" />
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <Label htmlFor="ForminputState" className="form-label">Grape<span style={{ color: "red" }}>*</span></Label>
                                                    <select value={formValues.grapeId} onChange={(e) => setFormValues({ ...formValues, grapeId: e.target.value })} id="ForminputState" className="form-select" data-choices data-choices-sorting="true" >
                                                        {
                                                            dropdownItems.grapes.map((item, index) => (
                                                                <option key={index} value={item.id}>{item.name}</option>
                                                            ))
                                                        }
                                                    </select>
                                                </div>
                                            </Col>
                                        </Row>
                                    </fieldset>
                                </Form>
                            </CardBody>
                        </Card>

                    </Container>
                </fieldset>
            </div>
        </>
    );
}

export default GrapeOfTheWeekDetails;